import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { ButtonType, ButtonWidget } from '../../../widgets/controls/ButtonWidget';
import { useSystem } from '../../../hooks/useSystem';
import { AuthCodes, RegisterCode } from '@foxbun/lib-goferal-types';
import { EmptyWidget } from '../../../widgets/content/EmptyWidget';
import { Notification, NotificationType } from '../../../core/stores/NotificationStore';
import { createPath } from 'react-router-dom';
import { RouteError } from '@foxbun/lib-errors';
import { Routing } from '../../Routing';

export const RegistrationCodesPage: React.FC = () => {
  const system = useSystem();
  const [codes, setCodes] = useState<RegisterCode[]>([]);
  const [loading, setLoading] = useState(true);
  const loadCodes = () => {
    setLoading(true);
    system.auth_client.listRegistrationCode(system.session_store.current_session.refresh_token).then((codes) => {
      setCodes(codes);
      setLoading(false);
    });
  };
  useEffect(() => {
    loadCodes();
  }, []);
  return (
    <S.Container>
      <ButtonWidget
        label="Generate code"
        action={() => {
          system.auth_client
            .generateRegistrationCode(system.session_store.current_session.refresh_token)
            .then(() => {
              loadCodes();
            })
            .catch((ex) => {
              if (ex instanceof RouteError) {
                if (ex.error.code === AuthCodes.NO_MORE_CODES_ALLOWED) {
                  system.notification_store.showNotification(
                    new Notification({
                      type: NotificationType.ERROR,
                      desc: 'No more codes left to generate! Contact us if you need more.'
                    })
                  );
                }
              }
            });
        }}
      />
      {codes.length === 0 && !loading ? (
        <EmptyWidget label="No codes generated" />
      ) : (
        <S.Codes>
          {codes.map((c) => {
            return (
              <S.Code key={c._id.toString()}>
                <S.CodeValue>
                  {c.code} {c.used ? '(used)' : ''}
                </S.CodeValue>
                {!c.used ? (
                  <ButtonWidget
                    type={ButtonType.SECONDARY}
                    label="Copy link"
                    action={() => {
                      let url = `${window.location.origin}/#${createPath({
                        pathname: Routing.REGISTER,
                        search: `code=${c.code}`
                      })}`;
                      console.log(url);
                      navigator.clipboard.writeText(url);
                    }}
                  ></ButtonWidget>
                ) : null}
              </S.Code>
            );
          })}
        </S.Codes>
      )}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  `;

  export const CodeValue = styled.div``;

  export const Codes = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  `;

  export const Code = styled.div`
    color: ${(p) => p.theme.button_secondary.foreground};
    padding: 5px;
    font-family: sans-serif;
    border-radius: 5px;
    background: ${(p) => p.theme.forms.background};
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;
}
